<template>
  <div class="journey-table-container">
    <div class="bottom-actions" v-if="selectedJourneyIds.length > 0">
      <span class="selected-label">{{$t('selected')}} {{selectedJourneyIds.length}} {{$t('journey')}}</span>
      <ActionDropdown :actions="userActions" :on-action="handleMultiAction"  :on-popup-action="handlePopAction" :placeholder="$t('actions')" />
    </div>
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th>{{$t('full_name')}}</th>
        <th>{{$t('e_mail')}}</th>
        <th>{{$t('status')}}</th>
        <th>Program</th>
        <th class="sortable-header" @click="toggleProgressSort">
          {{$t('progress_journeys')}}
          <img src="@/assets/images/status.svg" :class="{ 'sort-asc': sortOrder === 'asc', 'sort-desc': sortOrder === 'desc' }">
        </th>
        <th>{{$t('on_schedule')}}</th>
        <th>{{$t('actions_journey')}}</th>
      </tr>
      </thead>
      <tbody class="tbody-container" v-click-outside="tableOutsideClick">
      <tr class="tr-class" v-if="!loading" v-for="user in sortedUsers" :key="user.user?.userId">


        <td class="td-style">
          <router-link v-if="user.journeyId!==null" :to="'/journeys/' + user.journeyId">
            <div class="name-row" @click="activeGoDropdownId !== user.journeyId ? activeGoDropdownId = user.journeyId : activeGoDropdownId = -1">
              <img class="company-icon" :src="user.avatarUrl" v-if="user.avatarUrl" />
              <span class="test-class" :title="user.user?.fullName">{{ truncateText(user.user?.fullName, 30) }}</span>
            </div>
          </router-link>
          <div v-else>
          <div  class="name-row" @click="journeyCreateAlert">
            <img class="company-icon" :src="user.avatarUrl" v-if="user.avatarUrl" />
            <span class="test-class" :title="user.user?.fullName">{{ truncateText(user.user?.fullName, 30) }}</span>
          </div>
          </div>
        </td>

        <td class="td-style">
          <template v-if="user.user?.fullName">
            <span class="test-class">{{ truncateText(user.email, 30) }}</span>
          </template>
          <template v-else>
            <em class="no-data-text">N/A</em>
          </template>
        </td>



        <td class="td-style">
          <span class="active-tag" v-if="!user.status">{{$t('active')}}</span>
          <span class="ended-tag" v-else>{{$t('ended')}}</span>
        </td>



        <td class="td-style">
          <template v-if="user.program">
            <span class="test-class" :title="user.program">{{ truncateText(user.program, 30) }}</span>
          </template>
          <template v-else>
            <em class="no-data-text">N/A</em>
          </template>
        </td>

        <td class="td-style">
          <div class="progress-container">
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: (user.progress || 1) + '%' }"></div>
            </div>
            <span class="progress-text">{{ user.progress || 0 }}%</span>
          </div>
        </td>


        <td class="td-style">
          <template v-if="user.createdAt">
            <span class="test-class">{{ truncateText(user.createdAt, 30) }}</span>
          </template>
          <template v-else>
            <em class="no-data-text">N/A</em>
          </template>
        </td>

        <td>
          <div class="action-wrapper">
            <ActionDropdown v-if="user.journeyId!==null" :pop-direction="false" :actions="userActions" :on-action="(value) => {
              handleAction(value, user.journeyId, user?.user?.userId)
            }"  :on-popup-action="(popItemId,action) => {
              handleSinglePopAction(popItemId,action,user?.user?.userId)
            }" :placeholder="$t('actions')" />

            <div v-else class="journey-create-button" @click="createJourney(user.user.userId)">
              <span>{{$t('journey_created')}}</span>
            </div>
          </div>
        </td>
      </tr>

      <tr v-else>
        <td colspan="8" class="table-loading">
          <VueSpinner size="16" height="100%" color="#8c8c8c" />
          <span class="text">{{$t('loading')}}</span>
        </td>
      </tr>

      <tr v-if="!loading && users.length === 0 ">
        <td colspan="8" class="table-loading">
          <span class="text">{{$t('no_data_found')}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>


</template>

<script>
import AddUserModal from '@/components/modals/InviteUserModal.vue';
import FilterModal from '@/components/tables/Company/CompanyFilterModal.vue';
import CompanyFieldFilter from '@/components/table-filters/CompanyFieldFilter.vue';
import ProgramFilter from "@/components/table-filters/NumberFilter.vue";
import UserAmountFilter from "@/components/table-filters/MinMaxNumberFilter.vue";
import PaymentVolume from "@/components/table-filters/PaymentVolume.vue";
import DateFilter from "@/components/table-filters/DateFilter.vue";
import programNumberFilter from "../../table-filters/NumberFilter.vue";
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import {VueSpinner} from "vue3-spinners";
import ActionDropdown from "@/components/ActionDropdown.vue";
import journeyService from "@/service/journeyService";
import {handleErrorResponse, truncate} from "@/utils/utils";
import JourneyUserFilters from "@/components/tables/Journey/JourneyUserFilters.vue";
import notificationContentService from "@/service/notificationContentService";

export default {
  components: {
    JourneyUserFilters,
    ActionDropdown,
    DateFilter,
    PaymentVolume,
    UserAmountFilter,
    AddUserModal,
    FilterModal,
    CompanyFieldFilter,
    ProgramFilter,
    ExpandableSearch,
    VueSpinner
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    addNewUser: {
      type: Function,
      default: () => {}
    },
    users: {
      type: Array,
      required: true
    },
    rightAction: {
      type: Boolean,
      default: true
    },
    refreshData: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      notificationList:[],
      showModal: false,
      selectAll:false,
      showFilter:false,
      searchText: '',
      activeGoDropdownId: -1,
      activeActionDropdownId: -1,
      multiActionVisible: false,
      selectedJourneyIds: [],
      selectedUserIds:[],
      sortOrder: null
    }
  },
  computed: {
    userActions() {
      return [
        {
          name: this.$t('send_new_notification'),
          action: 'sendNotification'
        },
        {
          name: this.$t('choose_and_send_notification'),
          action: 'chooseNotification',
          pop: true,
          popupItems: this.notificationList.map(item => ({
            name: item.content.label,
            action:item.notificationId
          }))
        },
        {
          name: this.$t('end_the_journey'),
          action: 'endJourney'
        },
      ]
    },
    sortedUsers() {
      if (this.sortOrder === null) {
        return this.users;
      }

      return [...this.users].sort((a, b) => {
        const progressA = a.progress || 0;
        const progressB = b.progress || 0;

        if (this.sortOrder === 'desc') {
          return progressB - progressA;
        } else {
          return progressA - progressB;
        }
      });
    }
  },
  created() {
    this.getNotificationList();
  },
  methods: {
    createJourney(userId){
      const programId=this.$route.params.id
      journeyService.journeyCreate(userId,programId).then(() => {
        this.refreshData();
      }).catch((error) => {
        handleErrorResponse(error, this.$snackbar);
      });
    },
    journeyCreateAlert(){
      this.$snackbar.add({
        type:'warning',
        text: this.$t('journey_not_created_for_user')
      })
    },
    toggleProgressSort() {
      if (this.sortOrder === null) {
        this.sortOrder = 'desc';
      } else if (this.sortOrder === 'desc') {
        this.sortOrder = 'asc';
      } else {
        this.sortOrder = null;
      }
    },
    handleSinglePopAction(actionId,action, userId){
      if(action==='chooseNotification'){
        this.selectedUserIds.push(userId);
        this.sendNotification(this.selectedUserIds,actionId)
        this.selectedUserIds=[];
        this.selectedJourneyIds=[];
      }

    },
    handlePopAction(actionId,action){
      if(action==='chooseNotification'){
        console.log("Buraya geldi");
        this.sendNotification(this.selectedUserIds,actionId)
        this.selectedUserIds=[];
        this.selectedJourneyIds=[];
      }

    },
    sendNotification(userIds,notificationDataId){
      notificationContentService.sendNotification(userIds,notificationDataId).then((res) => {
        if(res.data.data.failedNotifications.length > 0){
          this.$snackbar.add({
            text: this.$t("some_notifications_failed"),
            type: "failed"
          });
        }else{
          this.$snackbar.add({
            text: this.$t('selected_notification_assigned'),
            type: 'success'
          });
        }
      })
    },
    getNotificationList() {
      notificationContentService.getNotificationContentList(true)
          .then(response => {
            this.notificationList=response.data.data;
          })
          .catch(error => {
            handleErrorResponse(error);
          });
    },
    truncate,
    handleSearch(event) {
      this.searchText = event.target.value;
    },
    toggleJourney(e, journeyId, userId) {
      if (e.target.checked) {
        this.selectedJourneyIds.push(journeyId);
        this.selectedUserIds.push(userId)
      } else {
        this.selectedJourneyIds = this.selectedJourneyIds.filter(id => id !== journeyId);
        this.selectedUserIds = this.selectedUserIds.filter(id => id !== userId);

      }
    },

    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    },

    getSafeValue(value) {
      return value && value !== "" ? value : "N/A";
    },

    tableOutsideClick() {
      this.activeGoDropdownId = -1;
    },
    handleMultiAction(action) {
      if (action === 'endJourney' && this.selectedJourneyIds.length > 0) {
        journeyService.endJourney(this.selectedJourneyIds)
            .then(() => {
              this.selectedJourneyIds = [];
              this.selectedUserIds=[];
              this.$snackbar.add({
                text: this.$t('selected_journeys_ended'),
                type: 'success'
              });
            })
            .catch(err => {
              handleErrorResponse(err, this.$snackbar);
            });
      } else if (action === 'sendNotification' && this.selectedJourneyIds.length > 0) {
        this.multiActionVisible = true;
        const userIds = this.selectedJourneyIds.map(id => {
          return this.users.find(user => user.journeyId === id).user.userId;
        });

        window.location.href = `/notification/new?userIds=${userIds.join(',')}`;
      }

      this.refreshData();
    },
    handleAction(action, journeyId, userId) {
      if (!userId) {
        return;
      }

      if (action === 'endJourney') {
        journeyService.endJourney([journeyId])
            .then(() => {
              this.$snackbar.add({
                text: this.$t('selected_journeys_ended'),
                type: 'success'
              });
            })
            .catch(err => {
              handleErrorResponse(err, this.$snackbar);
            });
      } else if (action === 'sendNotification') {
        window.location.href = `/notification/new?userIds=${userId}`;
      } else if (action === 'sendOffer') {
        console.log(this.selectedJourneyIds, action)
      } else if (action === 'offerAccepted'){}
      console.log(this.selectedJourneyIds, action)

      this.refreshData();
    },
  },

}
</script>

<style scoped>
.sortable-header {
  cursor: pointer;
  user-select: none;
  position: relative;
}

.sortable-header:hover {
  background-color: #f5f5f5;
}

.sortable-header img {
  margin-left: 5px;
  width: 12px;
  height: 12px;
  transition: transform 0.2s ease;
}

.sortable-header img.sort-asc {
  transform: rotate(180deg);
}

.sortable-header img.sort-desc {
  transform: rotate(0deg);
}

.progress-container {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 100px;
}

.progress-bar {
  flex: 0.5;
  height: 8px;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  border:1px solid #000000;

}

.progress-fill {
  height: 100%;
  background-color: #4A68F8;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.progress-text {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #666;
  min-width: 35px;
  text-align: right;
}

.progress-fill[style*="width: 100%"] {
  background-color: #4CAF50;
}

.content-table{
  overflow: visible;
}
.journey-table-container {
  width: 100%;
  max-width: 100%;
  overflow: visible;
}

.company-icon {
  height: 32px;
  width: 32px;
  border-radius: 50%;
}


.name-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  cursor: pointer;
}

.name-row span {
  font-family: euclid_medium, sans-serif;
  color: #000;
}

.name-row:hover.name-row span{
  color: #4A68F8;
}

.dropdown-body {
  position: absolute;
  background-color: #f1f1f1;
  padding: 10px;
  border-radius: 8px;
  top: 40px;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  z-index: 999999;
}

.dropdown-option {
  cursor: pointer;
  font-size: 12px;
  padding: 7px 15px;
  display: block;
  border-radius: 8px;
}

.dropdown-option:hover {
  background: #ffffff;
}

.action-wrapper {
  position: relative;
}

.bottom-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.selected-label {
  font-family: euclid_medium, sans-serif;
  font-size: 10px;
  color: #000;
  font-feature-settings: 'clig' off, 'liga' off;
  font-style: normal;
  line-height: 16px;
}

.active-tag {
  font-family: euclid_medium, sans-serif;
  font-size: 10px;
  color: #4A68F8;
  font-feature-settings: 'clig' off, 'liga' off;
  font-style: normal;
  line-height: 16px;
}

.ended-tag {
  font-family: euclid_medium, sans-serif;
  font-size: 10px;
  color: #FF0000;
  font-feature-settings: 'clig' off, 'liga' off;
  font-style: normal;
  line-height: 16px;
}


.tr-class {
  position: relative;
}
.journey-create-button {
  cursor: pointer;
  font-size: 12px;
  padding: 7px 15px;
  border-radius: 12px;
  background-color: #eaecf0;
}
.journey-create-button span{
  display: flex;
  text-align: center;
  justify-content: center;
}
</style>
